/* This is the EMIS Student for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + curacc"></span>
    </div>
    <div>
      <table
        style="height: 87px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">
              អាយុ
              <p>(ឆ្នាំ)</p>
            </td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៧</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៨</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៩</td>
            <td class="row-header-title" colspan="4">
              សរុបសិស្សមធ្យមសិក្សាបឋមភូមិ
            </td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr v-for="(value, row) in ageLow.length - 1" :key="row">
            <!-- Draw only 16 columns -->
            <td class="col-title">{{ ageLow[row] }}</td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              :class="[!lowOnOff[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!lowOnOff[row][col]"
                class="number"
              />
            </td>
            <!-- total in each row -->
            <td class="row-data">
              <strong>{{ col1[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col2[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col3[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col4[row] }}</strong>
            </td>
          </tr>
          <!-- Total each column -->
          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 12" :key="col" class="row-data">
              <strong>{{ totalRow[col] | blank }}</strong>
            </td>
            <!-- Total each row and column -->
            <td class="row-data">
              <strong>{{ tCol1 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol2 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol3 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol4 | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { ageLow, stulowOnOff } from "@/utils/ascf/secConfig.js";
export default {
  props: ["data", "curacc", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      ageLow: ageLow,
      lowOnOff: stulowOnOff,
    };
  },
  // Compute function for student sec
  computed: {
    /* col1, col2, col3 and col4 are computed function in each row by age and total/gender */
    col1: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col3: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 2) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col4: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 3) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    /* totalRow are the summing of each column total and female */
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    /* tCol1, tCol2, tcol3 and tcol4 are the total of total row and column */
    tCol1: function () {
      return this.totalRow[0] + this.totalRow[4] + this.totalRow[8];
    },
    tCol2: function () {
      return this.totalRow[1] + this.totalRow[5] + this.totalRow[9];
    },
    tCol3: function () {
      return this.totalRow[2] + this.totalRow[6] + this.totalRow[10];
    },
    tCol4: function () {
      return this.totalRow[3] + this.totalRow[7] + this.totalRow[11];
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "0";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header-title {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.col-title {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>